import { createAction } from "@reduxjs/toolkit";

export const getActiveTabId = createAction<string>("tabs/getActiveTabId");
export const getTabsStatus = createAction<string>("tabs/getTabsStatus");
